// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { change } from 'redux-form'
import { PATH_REPORT_EXPORT } from './constants'

// NOTE - we only allow the user to set underline to true if
// they're accessing the path report export via project summary
// and they've checked docx or pdf as one of their export types.

// e is the change Event
// c is redux-form's change handler for this field.
export const handleExportTypesChange = (e, c) => (dispatch, getState) => {
  // allow the value to update in redux form
  c(e)

  const {
    pathExportTypes,
    underline,
  } = getState().form[PATH_REPORT_EXPORT].values

  // underline is a single checkbox but is handled as an array in redux-form
  // so if it has length, then it should be considered true
  // if it does not have length, it should be considered false.
  // and
  // if neither docx nor pdf are included in the list of types,
  // then set underline to false since the other file types do not support underlining.
  if (underline.length && !(pathExportTypes.includes('docx') || pathExportTypes.includes('pdf'))) {
    dispatch(change(PATH_REPORT_EXPORT, 'underline', []))
  }
}
